import { Link } from '@tanstack/react-router';

import { Card, CardFooter } from 'src/shared/components/ui/card';
import { Separator } from 'src/shared/components/ui/separator';

interface AuthErrorProps {
  redirectUrl: string;
}

export default function AuthError({ redirectUrl }: AuthErrorProps) {
  return (
    <div>
      <img src="/static/images/tekst-logo.svg" width={80} height={20} className="mx-auto mb-4" alt="Tekst logo" />
      <Card className="w-[400px] px-7 pt-6 pb-2 space-y-6">
        <div className=" w-full text-center">
          <p className="text-neutral-400">Something went wrong logging you in.</p>
        </div>
        <div className="text-center text-neutral-950">
          <p>Please try again.</p>
          <Separator className="my-4 w-[50%] mx-auto" />
          <p className="text-neutral-500 text-sm">If the problem persists, please contact support.</p>
        </div>
        <CardFooter className="flex-center pb-0">
          <div>
            <Link to={redirectUrl} className="mt-5 flex-center text-neutral-400 text-xs hover:underline">
              Back to login
            </Link>
          </div>
        </CardFooter>
      </Card>
    </div>
  );
}
